import { render, staticRenderFns } from "./CreateProjectDialog.vue?vue&type=template&id=78268c21&"
import script from "./CreateProjectDialog.ts?vue&type=script&lang=ts&"
export * from "./CreateProjectDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports